import React from "react";

export const Footer = () => {
    return (
    <footer>
        <p>Payment is processed by Stripe, provided by Askevold Be. Orgnr 998302021.
           Your email address and payment details will be stored for event registration.</p>
    </footer>)
}